// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var sectionContainer = "TabbedListSection-module--sectionContainer--3o0Lp";
export var noPaddingTop = "TabbedListSection-module--noPaddingTop--3N18u";
export var section = "TabbedListSection-module--section--38nSB";
export var withMinHeight = "TabbedListSection-module--withMinHeight--29n76";
export var title = "TabbedListSection-module--title--RL2Od";
export var tabbedListContainerDesktop = "TabbedListSection-module--tabbedListContainerDesktop--BQobV";
export var backgroundWatermarkContainer = "TabbedListSection-module--backgroundWatermarkContainer--34vuO";
export var tabsTitleContainer = "TabbedListSection-module--tabsTitleContainer--2rYkV";
export var tabTitle = "TabbedListSection-module--tabTitle--1Lu2a";
export var active = "TabbedListSection-module--active--39KaH";
export var tabsTextContainer = "TabbedListSection-module--tabsTextContainer--s8v0e";
export var tabImagesContainer = "TabbedListSection-module--tabImagesContainer--r55xF";
export var image = "TabbedListSection-module--image--2xHyg";
export var tabbedListContainerMobile = "TabbedListSection-module--tabbedListContainerMobile--1w937";